import * as R from 'ramda';
import { _Boolean, UserByTenantLandscapeQueryVariables } from '@/API';
import {
  getUsersByTenantLandscape,
  UserByTenantLandscapeQuery,
} from '@/appsync/graphql/user';
import { graphqlQuery } from '@/appsync/service/GraphqlUtils';
import { LoginInfo, LoginNameAndUserRole } from '@/types/type';
import { _booleanEnum2userRoleTypes } from '@/utils/UserManagementUtils';

export const fetchUsers = async (
  loginInfo: LoginInfo
): Promise<LoginNameAndUserRole[]> => {
  const tenant = loginInfo.tenant;
  const landscape = loginInfo.landscape;
  let isFirstPage = true;
  let nextToken: string | undefined | null = null;
  const users: LoginNameAndUserRole[] = [];

  while (isFirstPage || nextToken) {
    isFirstPage = false;
    const variables: UserByTenantLandscapeQueryVariables = {
      tenant,
      landscape: {
        eq: landscape,
      },
      limit: 1000,
      nextToken,
    };
    const result = await graphqlQuery<
      UserByTenantLandscapeQuery,
      UserByTenantLandscapeQueryVariables
    >(getUsersByTenantLandscape, variables);

    const formattedUserInfo: LoginNameAndUserRole[] = formatUserInfo(
      R.defaultTo([], R.path(['userByTenantLandscape', 'items'], result))
    );

    users.push(...formattedUserInfo);
    nextToken = R.path(['userByTenantLandscape', 'nextToken'], result);
  }

  return users;
};

const assocUserRole = (user: {
  loginName: string;
  isAdmin: _Boolean;
  roleId?: string | null;
}) =>
  R.pipe(
    R.assoc('userRole', _booleanEnum2userRoleTypes(user.isAdmin)),
    R.assoc('roleId', user.roleId || null)
  )(user);

const formatUserInfo = (
  users: {
    loginName: string;
    isAdmin: _Boolean;
    roleId?: string | null;
  }[]
) =>
  R.map(R.pipe(assocUserRole, R.pickAll(['loginName', 'userRole', 'roleId'])))(
    users
  ) as LoginNameAndUserRole[];
